import React, { useMemo } from 'react';
// 1. Import ChartJS and the specific components needed
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import LoadingBars from '../../elements/LoadingBars';
import { BAR_COLOR, BAR_LABEL, getChartOptions } from './constants';
import styles from './styles.scoped.css';
import PropTypes from 'prop-types';

// 2. Register the components (do this outside the component function)
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

function BarChartMonitoring({ data, isLoading }) {
  const generatedData = useMemo(() => {
    const labels = [];
    const datasets = {
      registered: {
        data: [],
        backgroundColor: BAR_COLOR.REGISTRASI_BERHASIL,
        label: BAR_LABEL.REGISTRASI_BERHASIL,
      },
      onboarding: {
        data: [],
        backgroundColor: BAR_COLOR.SUDAH_ONBOARDING,
        label: BAR_LABEL.SUDAH_ONBOARDING,
      },
      transaction: {
        data: [],
        backgroundColor: BAR_COLOR.SUDAH_TRANSAKSI,
        label: BAR_LABEL.SUDAH_TRANSAKSI,
      },
    };

    data?.forEach((dt) => {
      labels.push(dt?.label);
      datasets.registered.data.push(dt?.registered);
      datasets.onboarding.data.push(dt?.onboarding);
      datasets.transaction.data.push(dt?.transaction);
    });

    return {
      labels,
      datasets
    };
  }, [data]);

  return (
    <>
      {isLoading ? (
        <div className={styles['loading-container']}>
          <LoadingBars size={10} />
        </div>
      ) : (
        <Bar
          data={{
            labels: generatedData.labels,
            datasets: [
              generatedData.datasets.registered,
              generatedData.datasets.onboarding,
              generatedData.datasets.transaction
            ],
          }}
          options={getChartOptions()}
        />
      )}
    </>
  );
}

BarChartMonitoring.propTypes = {
  data: PropTypes.array,
  isLoading: PropTypes.bool
};

export default BarChartMonitoring;
